$(document).ready(function () {

    // Dupliquer le menu desktop
    // $('#mobile-menu ul').html($('#desktop-menu ul').html());

    // Initialisation du menu de services
    $("#btn-menu-services").attr('data-content', $('#menu-services').html());

    // Initialise les popover
    $('[data-toggle="popover"]').popover();


    // Initialiser la personnalisation des selects
    $('select').selectpicker();

    // SLIDER

    $('.slider').slider();

    // Initialisation des datesPicker
    //$('.datepicker, .input-group.date').attr({'readonly': 'readonly'}).datepicker({todayHighlight: true, clearBtn: true, language: "fr", autoclose: true});
    $('.datepicker, .input-group.date').datepicker({startDate: new Date(), todayHighlight: true, clearBtn: true, language: "fr", autoclose: true});

    // Initialise les input radio stylés
    $('.checkbox, .radio').click(function () {
        $(this).find('label').removeClass('active');
        $(this).find('input:checked').parent('label').addClass('active');
    });
    $('.checkbox, .radio').each(function () {
        $(this).find('label').removeClass('active');
        $(this).find('input:checked').parent('label').addClass('active');
    });

    // Initialisation du menu
    $('.btn-menu, .overlay').click(
            function () {
                if ($('#main-menu').hasClass('open')) {
                    $('#main-menu, .overlay').removeClass('open');
                } else {
                    $('#main-menu, .overlay').addClass('open');
                }
            }
    );

    $(document).keyup(function (e) {
        if (e.keyCode == 27) { // escape key maps to keycode `27`
            $('#main-menu, .overlay').removeClass('open');
        }
    });



    // show-hide-btn
    $('.show-hide-btn').each(function () {
        $('.show-hide-btn').find('span').addClass($(this).attr('data-hide-icon'));
    });

    $('.show-hide-btn').click(function () {
        $(this).find('span').addClass($(this).attr('data-show-icon'));
    });


    $('.show-hide').click(function () {

        var toHide = $(this).attr('data-hide');
        var toShow = $(this).attr('data-show');
        var parent = $(this).attr('data-parent');

        $(parent).find('.show-hide').removeClass('active');
        $(this).addClass('active');

        if (toHide != '') {
            $(toHide).removeClass('active').hide();
        }

        if (toShow != '') {
            $(toShow).removeClass('hidden');
            $(toShow).addClass('active').show();
        }

    });


    // Effet notification

    $('.notification .badge').fadeOut().fadeIn().fadeOut().fadeIn();

    // Cacher le loader ajax après le chargement de la page

    $('.ajax-loader').hide();

    $('.panel-heading').has('[data-toggle=collapse]').addClass('bg-gris-6');

    $('.panel-heading [data-toggle=collapse]').click(function () {
        var dataParent = $(this).attr('data-parent');
        $(dataParent + ' .panel-heading').removeClass('active');
        $(this).parent('.panel-heading').addClass('active');
    });



    $('.enable-disable').click(function () {

        var toEnable = $(this).attr('data-enable');
        var toDisable = $(this).attr('data-disable');

        if (toEnable != '') {
            $(toEnable).removeAttr('disabled').removeClass('disabled');
        }

        if (toDisable != '') {
            $(toDisable).attr('disabled', 'disabled').addClass('disabled');
        }

    });


    $('.lien-volet-aide').click(function () {
        if ($(this).attr('data-action') == 'ouvrir') {
            $('.volet_aide').animate({left: '-4px'});
            $(this).attr('data-action', 'fermer');
        } else {
            $('.volet_aide').animate({left: '-235px'});
            $(this).attr('data-action', 'ouvrir');
        }
    });




    //Affichage des videos tutos
    $('.tutoriel').click(function(){

      var urlVideo = $(this).attr('data-url-video');
      var titreVideo = $(this).find('h3').html();
      var descriptionVideo  = $(this).find('p').html();

      $('#video-modal').find('h4').html(titreVideo);
      $('#video-modal').find('video').html(descriptionVideo);
      $('#video-modal').find('video').attr('src', urlVideo);

    });

    // TO DO : Mettre dans la bibliothèque
    // Compter le nombre de caractère

    $('.rating-comment-response textarea').on('keyup change', function () {
        var text = $(this).val();
        max = 300;
        textLength = text.length;
        if (textLength < max) {
            $($(this).attr('data-compteur')).html((    textLength + '/' + max  ));
        } else {
            $(this).val(text.substring(0, max));
            $($(this).attr('data-compteur')).html(( max + '/' + max  ));
        }
    });

    $('#modal-code-postal').modal('show');

    $( "#select-publi" ).change(function() {
      if (this.value === "lien") {
        $("#picto").removeClass("pictogramme-svg-fichier");
        $("#picto").addClass("pictogramme-svg-liens");
        $("#telecharger-docu").hide()
        $("#ajout-lien").show()
      }
      else if (this.value === "document") {
        $("#picto").removeClass("pictogramme-svg-liens");
        $("#picto").addClass("pictogramme-svg-fichier");
        $("#ajout-lien").hide()
        $("#telecharger-docu").show()
      }
    });

    // $('#picto').modal('show');
	
    // Changer en mode sticky header après le scroll

    var header = $("header");

    var windowHeight = window.innerHeight/3 ;

    $(window).scroll(function () {

        if (window.pageYOffset > 1) {
            header.addClass("sticky-header");
            $('main').css("margin-top", header.height());
        } else {
            header.removeClass("sticky-header");
            $('main').css("margin-top", '0px');
        }

    });

});
